/**
 * Created by alex.y on 12/11/2017.
 */
export enum ProductSearchType{
    ProductHsCode,
    ProductQuery,
    VehicleQuery,
    VehicleHsCode,
}


// WEBPACK FOOTER //
// ./app/objects/products/productSearchType.ts